import { useContext, useEffect, useState } from "react"
import { config } from "../context/config"
import { displayData, update } from "../components/indexDB/indexDBStora";
import { dataa } from "../context/data";
import { auth } from "../context/auth";
import { switchh } from "../context/switch";
import '../style/pages/MonitorBike.css';
import { CurrentTime } from "../funcs/current";
import { useDebounce } from '../funcs/hooks/useDebounce';
import { Setting } from "../context/settings";
import { CheckUserAtt } from "../funcs/checkAtt";
import { MakeAsync } from "../funcs/MakeAsync";
import { useTranslation } from "react-i18next";

export default function MonitorBike () {
    const { t } = useTranslation();
    const {stylingNav} = useContext(config);
    const { user } = useContext(auth)
    const { storeBusniessRules } = useContext(Setting);
    const {invoices, setInvoices, setScene} = useContext(dataa);
    const {setLoadingProcess, loadingProcess} = useContext(switchh);
    const [select,setSelect] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [pilots, setPilots] = useState([]);
    const [search, setSearch] = useState({
        ID_del: "",
        orderNum: "",
        phone_num: ""
    })


    useEffect(() => {
        const getAll =  async() => {
            const today = CurrentTime(false, true);
            const getEmpDay = await CheckUserAtt(today,'',"notBolean");
            const getPilots = getEmpDay.filter((item) => item.job === "pilot" && item.date.end === '');
            setPilots(getPilots);
        }
        getAll()
    }, [])

    useEffect(() => {
        setLoadingProcess(true);
        const getInvoices = async () => {
            const data = await displayData("invoices");
            if(data) {
                // the order of delivery should be not collected
                const filter = data.filter((e) => e.client_data.client_name !== '' && !e.delivery.isCollect && e.client_data.mode === "delivery");
                setInvoices(filter);
            }
            setLoadingProcess(false)
        }
        getInvoices()
        setRefresh(false)
    }, [refresh])

    const slectDlievery = async (id, del_id) => {
        const data = invoices.find((item) => item.id === id);
        try {
            console.log(del_id);
            // set Id of delivery
            data.delivery.deliveryID = del_id;
            data.delivery.exit = CurrentTime();
            // set exit of delivery 
            const desicion = MakeAsync(data, "update");
            await update("invoices", desicion);
            setSelect(del_id);
        }
        catch(error) {
            console.log(error);
        }
    }

    const collected = async (id) => {
        setRefresh(true);
        const data = invoices.find((item) => item.id === id);
        if(!data.delivery.deliveryID) return;
        data.delivery.isCollect = true;
        const desicion = await MakeAsync(data, "update");
        await update("invoices", desicion);
        setRefresh(false);
    }
    
    const ExitTime = (date) => {
        if(!date) {
            return {txt: "-------"};
        }

        const now = new Date();
        const exit = new Date(date);
        const diffTime = now - exit;
        const hours = Math.floor(diffTime / (1000 * 60 * 60));
        const minutes = Math.floor((diffTime / (1000 * 60)) % 60);
        return {
            h: hours, 
            m: minutes, 
            txt: `ساعة ${hours} - دقيقة ${minutes}`};
    }
    const statusRow = (data) => {
        const time = data.h * 60 + data.m;
        
        const normalMax =
        (storeBusniessRules?.monitorPilots?.normal?.hours || 0) * 60 +
        (storeBusniessRules?.monitorPilots?.normal?.min || 0);

        const warningMax =
        (storeBusniessRules?.monitorPilots?.warning?.hours || 0) * 60 +
        (storeBusniessRules?.monitorPilots?.warning?.min || 0);

        const dangerMax =
        (storeBusniessRules?.monitorPilots?.danger?.hours || 0) * 60;


        if (time <= normalMax) return 'normal-bg-v2';
        if (time <= warningMax) return 'warning-bg-v2';
        if (time <= dangerMax) return 'error-bg-v2';

        return '';
    };


    const searching = useDebounce(search, 500);
    useEffect(() => {
        if(searching) {
            setLoadingProcess(false)
        };
    }, [searching])

    const handleChange = (key, value) => {
    setLoadingProcess(true);
    setSearch(prev => ({ ...prev, [key]: value }));
    };

    const displayInvoice = async (orderNum) => {
        const data = await displayData("invoices");
        if(!data) return;
        const display = data.find((e) => e.order_number === orderNum).data;
        setScene(display)
    }
    return (
        <div className={`monitor-delivery page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <h2>{t("sections:orderMontoring")}</h2>
            <div className="controll flex flex-space-bet">
                <input value={search.orderNum}  onChange={(e) => handleChange("orderNum", e.target.value)} type="number" min={'0'} placeholder={t("common:order")} />
                <input value={search.phone_num}  onChange={(e) => handleChange("phone_num", e.target.value)} type="number" min={'0'} placeholder={t("label:monitorPilots.orderNum")} />
                
                <select value={search.ID_del}  onChange={(e) => handleChange("ID_del", e.target.value)}>
                    <option value={''}>{t("label:monitorPilots.choosePilot")}</option>
                    {pilots.map((e, i) =>
                        <option key={i} value={`${e.fullName} #${e.code}`}>{e.fullName}</option>
                    )}
                </select>
                <div className="flex action-btns">
                    <button>{t("common:report")}</button>
                    <button onClick={() => setRefresh(true)}>{t("common:update")}</button>
                </div>
            </div>
            <p>{loadingProcess && t("common:searching")}</p>
            <div className="display">
                <table className="table-page">
                    <thead>
                        <tr>
                            <th>{t("common:order")}</th>
                            <th>{t("label:monitorPilots.orderNum")}</th>
                            <th>{t("placeholder:CRM.clientName")}</th>
                            <th>{t("label:employee.address")}</th>
                            <th>{t("common:time")}</th>
                            <th>{t("common:exit")}</th>
                            <th>{t("label:monitorPilots.delay")}</th>
                            <th>{t("common:details")}</th>
                            <th>{t("common:Collection")}</th>
                            <th>{t("label:monitorPilots.pilot")}</th>
                            <th>{t("common:action")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!loadingProcess &&
                        invoices
                        .filter((item) =>
                            (!searching.orderNum || item.order_number === Number(searching.orderNum)) &&
                            (!searching.phone_num || String(item.client_data.phone_number).includes(searching.phone_num)) &&
                            (!searching.ID_del || item.delivery.deliveryID === searching.ID_del)
                        )
                        .map((e,i) => 
                        <tr className={statusRow(ExitTime(e.delivery.exit))}>
                            <td>{e.order_number}</td>
                            <td>{e.client_data.client_name}</td>
                            <td>{e.client_data.phone_number}</td>
                            <td>{e.client_data.address}</td>
                            <td>{e.meta.createdAt}</td>
                            <td>{e.delivery.exit || '-----'}</td>
                            <td>{ExitTime(e.delivery.exit).txt}</td>
                            <td>
                                <button onClick={() => displayInvoice(e.order_number)}>{t("common:display")}</button>
                            </td>
                            <td>{parseFloat(Number(e.total) + Number(e.client_data.payment)).toFixed(2)} {user.data[0].currency.symbol}</td>
                            <td>
                                <select disabled={e.delivery.deliveryID} onChange={(item) => slectDlievery(e.id, item.target.value)}>
                                    <option selected={e.delivery.deliveryID === ''} disabled>{t("label:monitorPilots.choosePilot")}</option>
                                    {pilots.map((e, i) =>
                                        <option key={i} value={`${e.fullName} #${e.code}`}>{e.fullName}</option>
                                    )}
                                </select>
                            </td>
                            <td className="flex action-btns">
                                <button className="btn">{t("action:print")}</button>
                                <button disabled={!e.delivery.deliveryID} className="btn" onClick={() => collected(e.id)}>{t("action:collected")}</button>
                            </td>
                        </tr>
                        )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}